export enum AnalysisType {
    FREE = 'ENUM.ANALYIS_TYPE.FREE',

    SUPPORT = 'ENUM.ANALYIS_TYPE.SUPPORT',

    SUPPORT_TMO = 'ENUM.ANALYIS_TYPE.SUPPORT_TMO',

    FREE_SUPPORT = 'ENUM.ANALYIS_TYPE.FREE_SUPPORT',

    TVG = 'ENUM.ANALYIS_TYPE.TVG',

    AVG = 'ENUM.ANALYIS_TYPE.AVG',

    FREE_GROUP = 'ENUM.ANALYIS_TYPE.FREE_GROUP',

    ADDITIONAL = 'ENUM.ANALYIS_TYPE.ADDITIONAL',

    AVERAGE = 'ENUM.ANALYIS_TYPE.AVERAGE',

    DERIVATIVE_GROUP = 'ENUM.ANALYIS_TYPE.DERIVATIVE_GROUP',

    LEMO = 'ENUM.ANALYIS_TYPE.LEMO',

    MUA = 'ENUM.ANALYIS_TYPE.MUA',

    SUPPORT_MUA = 'ENUM.ANALYIS_TYPE.SUPPORT_MUA',

    EMA = 'ENUM.ANALYIS_TYPE.EMA'
}
